export const DescriptionFunctions = [
    {
        id: 1,
        descricao: 'Emitir Receituário Agronômico',
        descricaoBreve: 'Prescreva defensivos em conformidade com a lei.',
    },
    {
        id: 2,
        descricao: 'Compêndio Agrícola',
        descricaoBreve: 'Banco de dados completo de defensivos.',
    },
    {
        id: 3,
        descricao: 'Atualização automática do banco de dados',
        descricaoBreve: 'Bulas sempre atualizadas conforme o MAPA.',
    },
    {
        id: 4,
        descricao: 'Restrição de produtos por estado',
        descricaoBreve: 'Evite erros na prescrição.',
    },
    {
        id: 5,
        descricao: 'Gerenciar ARTs/TRTs',
        descricaoBreve: 'Cadastre e controle suas ARTs/TRTs.',
    },
    {
        id: 6,
        descricao: 'Enviar receitas para Defesas Agropecuárias',
        descricaoBreve: 'Veja <a href="https://agroreceita.com.br/homologacao-defesas-agropecuarias/" target="_blank" rel="noreferrer noopener">mais detalhes</a> sobre seu estado',
    },
    {
        id: 7,
        descricao: 'Solicitar novos produtos/documentos',
        descricaoBreve: 'Peça inclusão/revisão de produtos facilmente.',
    },
    {
        id: 8,
        descricao: 'Relatórios e métricas',
        descricaoBreve: 'Acompanhe dados e performance das emissões.',
    },
    {
        id: 9,
        descricao: 'Assinatura eletrônica e digital',
        descricaoBreve: 'Cadastre sua assinatura no sistema.',
    },
    {
        id: 10,
        descricao: 'Emissão de receitas sem internet',
        descricaoBreve: 'Emita receituários offline no app Android.',
    },
    {
        id: 11,
        descricao: 'Emissão de receitas em lote',
        descricaoBreve: 'Emita múltiplas receitas de uma só vez.',
    },
    {
        id: 12,
        descricao: 'Integração Webhook',
        descricaoBreve: 'Conecte com seus sistemas via API.',
    },
    {
        id: 13,
        descricao: 'Previsão do tempo',
        descricaoBreve: 'Consulte clima da propriedade rural.',
    },
    {
        id: 14,
        descricao: 'Guia de aplicação',
        descricaoBreve: 'Gere orientações para aplicação correta.',
    },
    {
        id: 15,
        descricao: 'Cadastrar filiais',
        descricaoBreve: 'Gerencie múltiplas unidades centralizadas.',
    },
    {
        id: 16,
        descricao: 'Agenda e CRM',
        descricaoBreve: 'Organize compromissos e gerencie clientes.',
    },
    {
        id: 17,
        descricao: 'Emitir FDS (FISPQ) e Fichas de Emergência',
        descricaoBreve: 'Gere documentos de segurança atualizados.',
    }
];